<template>
    <o-card v-if="workshop" :title="$t('medtastic.thank_you')" class="col-lg-8 mx-auto d-block">
        <div class="mt-2">{{ $t('medtastic.thank_you_text') }}</div>

        <table class="table-responsive table-borderless mt-3">
            <tr>
                <td width="48%">{{ $t('core.title') }}</td>
                <td>{{ workshop.title }}</td>
            </tr>
            <tr>
                <td>{{ $t('core.date') }}</td>
                <td>{{ workshop.date|formatDate }}</td>
            </tr>
            <tr>
                <td>{{ $t('medtastic.location') }}</td>
                <td>{{ workshop.location }}</td>
            </tr>
            <tr>
                <td>{{ $t('medtastic.time') }}</td>
                <td>{{ workshop.time|formatTimeString }}</td>
            </tr>
        </table>

        <p v-if="workshop.email_comment != ''" v-html="workshop.email_comment"></p>

        <p>{{ $t('medtastic.email_registration_text') }}</p>

        <router-link to="/" class="btn btn-primary mb-3">
            {{ $t('medtastic.back_to_home') }}
        </router-link>
    </o-card>
    <o-card :shadow="false" :title="$t('core.page_not_found')" class="col-lg-8 m-auto" v-else>
        <router-link to="/" class="btn btn-primary">
            {{ $t('medtastic.back_to_home') }}
        </router-link>
    </o-card>

</template>

<script>
  import axios from 'axios'

  export default {
    layout: 'user',
    data () {
      return {
        workshop: []
      }
    },
    mounted () {
      this.workshopDetail()
    },
    methods: {
      workshopDetail: function () {
        axios.get('/api/medtastic/workshops/public', {params: {'filter[id]': this.$route.params.id}})
          .then((response) => {
            this.workshop = response.data.data[0]
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }
  }
</script>
